export const UPDATE_SINGLES = 'UPDATE_SINGLES';